export const CREATE_DATA_EXPORT_REQUEST = 'CREATE_DATA_EXPORT_REQUEST'
export const CREATE_DATA_EXPORT_SUCCESS = 'CREATE_DATA_EXPORT_SUCCESS'
export const CREATE_DATA_EXPORT_FAILURE = 'CREATE_DATA_EXPORT_FAILURE'

export const UPDATE_DATA_EXPORT_REQUEST = 'CHANGE_DATA_EXPORT_REQUEST'
export const UPDATE_DATA_EXPORT_SUCCESS = 'CHANGE_DATA_EXPORT_SUCCESS'
export const UPDATE_DATA_EXPORT_FAILURE = 'CHANGE_DATA_EXPORT_FAILURE'

export const ERASE_DATA_EXPORT_REQUEST = 'ERASE_DATA_EXPORT_REQUEST'
export const ERASE_DATA_EXPORT_SUCCESS = 'ERASE_DATA_EXPORT_SUCCESS'
export const ERASE_DATA_EXPORT_FAILURE = 'ERASE_DATA_EXPORT_FAILURE'

export const RESEND_DATA_EXPORT_KEY_REQUEST = 'RESEND_DATA_EXPORT_KEY_REQUEST'
export const RESEND_DATA_EXPORT_KEY_SUCCESS = 'RESEND_DATA_EXPORT_KEY_SUCCESS'
export const RESEND_DATA_EXPORT_KEY_FAILURE = 'RESEND_DATA_EXPORT_KEY_FAILURE'

export const FETCH_DATA_EXPORT_LIST_REQUEST = 'FETCH_DATA_EXPORT_LIST_REQUEST'
export const FETCH_DATA_EXPORT_LIST_SUCCESS = 'FETCH_DATA_EXPORT_LIST_SUCCESS'
export const FETCH_DATA_EXPORT_LIST_FAILURE = 'FETCH_DATA_EXPORT_LIST_FAILURE'
